<template>
	<div class="st-main-content">
		<div class="query-setting-box">
			<div class="query-setting-box-left">
				<div class="order-query-form-box" style="width: 180px;">
					<label for="start-date"><span class="">下单起始时间<i class="icon_select"></i></span> </label>
					<span class="order-query-form-input">
						<el-date-picker v-model="orderForm.createTimeBegin" type="datetime" placeholder="选择日期时间"
							class="setTimePicker" value-format="yyyy-MM-dd HH:mm:ss">
						</el-date-picker>
					</span>
				</div>
				<div class="order-query-form-box" style="width: 180px;">
					<label for="start-date">至：</label>
					<span class="order-query-form-input">
						<el-date-picker v-model="orderForm.createTimeEnd" type="datetime" placeholder="选择日期时间"
							class="setTimePicker" value-format="yyyy-MM-dd HH:mm:ss">
						</el-date-picker>
					</span>
				</div>
				<div class="order-query-form-box">
					<label for="start-date">订单号：</label>
					<span class="order-query-form-input"><input type="text" v-model="orderForm.waybillNo"
							name="start-date"></span>
				</div>
				<div class="order-query-form-box">
					<label for="start-date">货主名称：</label>
					<span class="order-query-form-input"><input type="text" v-model="orderForm.ownerName"
							name="start-date"></span>
				</div>
				<div class="order-query-form-box">
					<label for="start-date">车牌号：</label>
					<span class="order-query-form-input"><input type="text" v-model="orderForm.driverCarNo"
							name="start-date"></span>
				</div>
				<div class="order-query-form-box">
					<label for="start-date">司机姓名：</label>
					<span class="order-query-form-input"><input type="text" v-model="orderForm.driverName"
							name="start-date"></span>
				</div>
				<div class="order-query-form-box">
					<label for="start-date">订单状态：</label>
					<span class="order-query-form-input">
						<el-select v-model="orderForm.waybillState" placeholder="请选择" class="stSetSelect">
							<el-option v-for="item in waybillStateList" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</span>
				</div>
				<div class="order-query-form-box">
					<label for="start-date">货主手机：</label>
					<span class="order-query-form-input"><input type="text" v-model="orderForm.ownerPhone"
							name="start-date"></span>
				</div>
				<div class="order-query-form-box">
					<label for="start-date">司机手机：</label>
					<span class="order-query-form-input"><input type="text" v-model="orderForm.driverPhone"
							name="start-date"></span>
				</div>
				<div class="order-query-form-box" style="width: 80px;" v-if="isSuperAdmin">
					<label for="start-date">加盟订单：</label>
					<span class="order-query-form-input">
					  <el-select v-model="orderForm.isFranchise" placeholder="请选择" class="stSetSelect">
						<el-option v-for="item in stWaybillList" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					  </el-select>
					</span>
				</div>
				<div class="order-query-form-box" style="width: 80px;" v-if="isSuperAdmin">
					<label for="start-date">订单类型：</label>
					<span class="order-query-form-input">
						<el-select v-model="orderForm.createFrom" placeholder="请选择" class="stSetSelect">
							<el-option v-for="item in createFromList" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</span>
				</div>
			</div>
			<div class="order-query-form-box-right">
				<span class="order-query-form-submit stPointer" @click="searchList(true)">查询</span>
			</div>
		</div>
		<div class="data-table-box">
			<common-table
				ref="CommonTableRef"
				:tableColumns="tableColumns"
				:data="dataList"
				:showSummary="true"
				:showPage="togglePage"
				:loading="loading"
				:pageConfig="pageConfig"
				:countData="dataTotal"
				:bottomHandleArr="bottomHandleArr"
				@selectionChange="selectionChange"
				@currentChange="currentChange"
				@sizeChange="sizeChange"
			>
			</common-table>
		</div>
	</div>
</template>
<script>
	export default {
		name: 'OrderProfit',
		props: [],
		components: {},
		data() {
			return {
				dataList: [], //订单列表
				dataTotal: {},
				loading: false,
				pageConfig: {
					total: 0,
					pageSize: 100,
					currentPage: 1,
				},
				togglePage:false,
				bottomHandleArr: [
					{
						label: '导出',
						handler: () => this.exportTable()
					}
				],
				tableColumns: [
					{
						type: 'selection',
						fixed: 'left',
					},
					// {
					// 	type: 'index',
					// 	fixed: 'left',
					// 	title: '序号',
					// 	width: 60,
					// 	index: function(index) {
					// 		return index
					// 	}
					// },
					{
						title: '下单时间',
						key: 'createTimeFormatted',
						width: 170
					},
					{
						title: '始发地',
						key: 'consignShortAddress',
						width: 170
					},
					{
						title: '目的地',
						key: 'receiveShortAddress',
						width: 170
					},
					{
						title: '订单状态',
						key: 'stateDesc',
						width: 170
					},
					{
						title: '订单号',
						key: 'waybillNo',
						width: 170
					},
					{
						title: '货主名称',
						key: 'ownerName',
						width: 170
					},
					{
						title: '货主手机',
						key: 'ownerPhone',
						width: 170
					},
					{
						title: '司机姓名',
						key: 'driverName',
						width: 170
					},
					{
						title: '司机手机',
						key: 'driverPhone',
						width: 170
					},
					{
						title: '订单金额',
						key: 'ownerExpressFee',
						width: 170
					},
					{
						title: '付司机运费',
						key: 'driverExpressFee',
						width: 170
					},
					{
						title: '利润',
						key: 'profit',
						width: 170
					},
					{
						title: '重量',
						key: 'weight',
						width: 170
					},
					{
						title: '方数',
						key: 'volume',
						width: 170
					},
					// {
					// 	operate: true,
					// 	width: 170,
					// 	fixed: 'right',
					// 	title: '操作',
					// 	setBtns: (row, index) => {
					// 		let arr = []
					// 		arr.push({
					// 			label: '编辑',
					// 			handler: () => this.editOrder(row, index)
					// 		})
					// 		arr.push({
					// 			label: '删除',
					// 			handler: () => this.editOrder(row, index)
					// 		})
					// 		return arr
					// 	}
					// }
				],
				isSuperAdmin: false,
				orderForm: {
					createTimeBegin: null, // 下单起始时间  string  格式：yyyy-MM-dd HH:mm:ss
					createTimeEnd: null, // 下单结束时间  string  格式：yyyy-MM-dd HH:mm:ss
					waybillNo: null, // 订单号 number  
					ownerName: null, // 货主名称  string  
					driverCarNo: null, // 车牌号 string  
					driverName: null, //  司机姓名  string  
					driverPhone: null, // 司机手机  string  
					ownerPhone: null, //  货主手机  string  
					isFranchise: null,
					createFrom: null,
					waybillState: "0", // 运单状态 number 0 = 未接单、 1 = 已接单、 2 = 运输中、 3 = 已完成、 99 = 已取消
				},
				stWaybillList:[
					{
						value: null,
						label: '全部',
					},
					{
						value: 0,
						label: '未加盟',
					},
					{
						value: 1,
						label: '已加盟',
					},
				],
				waybillStateList: [{
					value: '0',
					label: '未接单'
				}, {
					value: '1',
					label: '已接单'
				}, {
					value: '2',
					label: '运输中'
				}, {
					value: '3',
					label: '已完成'
				}, {
					value: '99',
					label: '已取消'
				}],
				createFromList: [
					{
						value: null,
						label: '全部',
					},
					{
						value: 'OWNER',
						label: '普通单',
					},
					{
						value: 'ADMIN',
						label: '拼单',
					}
				],

			}
		},
		created() {

		},
		methods: {
			selectionChange(list) {
				console.log(list)
			},

			editOrder(row) {
				alert(row)
			},

			sizeChange(size) {
				this.pageConfig.currentPage = 1
				this.pageConfig.pageSize = size
				this.searchList()
			},

			currentChange(currentPage) {
				this.pageConfig.currentPage = currentPage
				this.searchList()
			},

			searchList(flag) {
				let pages = {};
				pages.size = this.pageConfig.pageSize;
				pages.current = this.pageConfig.currentPage;
				if(flag) pages.current = 1;
				this.loading = true
				let orderForm = JSON.parse(JSON.stringify(this.orderForm));
				orderForm.createTimeBegin = orderForm.createTimeBegin ? new Date(orderForm.createTimeBegin).getTime() : ''
        		orderForm.createTimeEnd = orderForm.createTimeEnd ? new Date(orderForm.createTimeEnd).getTime() : ''
				Object.assign(orderForm, pages)
				this.$server.business.getWaybillCount(orderForm, (res) => {
					this.dataTotal = res.data
				})
				this.$server.business.waybillPage(orderForm, (res) => {
					this.loading = false
					if (res.code == 0) {
						this.dataList = res.data.records;
						this.pageConfig.total = res.data.total;
						this.pageConfig.currentPage = res.data.current;
						if(res.data.total>0){
							this.togglePage=true;
						}
					}
				})
			},

			// 导出
			exportTable() {
				let that = this;
				if (this.dataList.length === 0) {
					that.$toast.stMessage('暂无订单', true)
					return;
				}
				let pages = {};
				pages.size = this.pageConfig.pageSize;
				pages.current = this.pageConfig.currentPage;
				const sendData = {
					...this.orderForm,
					exportColumnFiledNames: this.getExportColumnFiledNames()
				}
				sendData.createTimeBegin = sendData.createTimeBegin ? new Date(sendData.createTimeBegin).getTime() : ''
        		sendData.createTimeEnd = sendData.createTimeEnd ? new Date(sendData.createTimeEnd).getTime() : ''
				Object.assign(sendData, pages)
				this.$server.common.exportTable('/business/waybill-page-export', sendData, (res) => {
					console.log('导出成功')
				})
			},

			getExportColumnFiledNames() {
				return this.tableColumns.map(item => {
					return item.key
				})
			}
		},
		mounted() {
			// 判断是否是超级管理员
			this.$server.role.getRoleOfUser(this.$store.getters.id, res => {
				if (res.data.length > 0) {
					this.isSuperAdmin = true
				}
			})
		}
	}

</script>
<style scoped>
	.order-profit {
		width: 100%;
		height: auto;
	}

	.data-table-box {
		height: auto;
		background: #FFF;
		padding: 8px;
		box-sizing: border-box;
	}

	.data-table {
		margin-bottom: 8px;
	}

	.query-setting-box-left {
		flex-grow: 0;
	}
</style>